<template>
  <Modal
    :width="780"
    title="原生锚点选择"
    class-name="vertical-center-modal"
    v-model="state"
    :mask-closable="false"
    :closable="false"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="!show"></Spin>
    <div class="data-table">
      <div class="filter">
        <Input v-model.trim="search" placeholder="请输入名称进行搜索" class="input" search enter-button @on-search="handleSearch"></Input>
        <Select v-model="type" style="width: 200px; margin-left: 20px" placeholder="请选择锚点状态" clearable @on-change="getData">
          <Option value="CREATE" label="锚点新建"></Option>
          <Option value="AUDIT_SUCCESS" label="审核通过"></Option>
          <Option value="AUDIT_FAILD" label="审核不通过"></Option>
        </Select>
      </div>
      <Table height="440" stripe :columns="columns" :data="dataList" @on-selection-change="selectionFn"></Table>
    </div>
    <Page
      v-if="total"
      class="page-index"
      show-total
      :current.sync="pageIndex"
      :total="total"
      :page-size="pageSize"
      @on-change="changePageIndex"
    />
    <div slot="footer">
      <Button type="text" size="large" @click="$emit('on-close')">取消</Button>
      <Button type="primary" size="large" @click="asyncSelect">确定</Button>
    </div>
  </Modal>
</template>
<script>
import { nativeAnchorGet } from '@/api/toutiao.model'
import { isArray } from '@/common/js/utils'
export default {
  name: 'AnchorData',
  props: {
    value: {
      type: Boolean
    },
    account: {
      type: Number
    },
    packageAndroid: {
      type: [String, Object]
    },
    packageIos: {
      type: [String, Object]
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 请求数据
    getData() {
      nativeAnchorGet({
        adAccountId: this.account,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        status: this.type,
        anchorName: this.search,
        android_package_name: this.packageAndroid,
        ios_package_name: this.packageIos
      }).then((data) => {
        this.show = true
        if (data) {
          if (data.list && isArray(data.list)) {
            this.dataList = data.list
            this.dataList.forEach((d) => {
              if (d.status !== 'AUDIT_SUCCESS') this.$set(d, '_disabled', true)
            })
          }
          if (data.page_info) this.total = data.page_info.total_number
        }
      })
    },
    bindGetData(val) {
      if (val) {
        this.show = null
        this.getData()
      } else {
        this.show = null
        this.currentRow = undefined
        this.search = ''
        this.pageIndex = 1
      }
    },
    changePageIndex(index) {
      this.show = null
      this.pageIndex = index
      this.getData()
    },
    selectionFn(selection) {
      this.selection = selection
    },
    asyncSelect() {
      if (this.selection.length > 1) {
        this.$Message.warning('最多只能选一个锚点')
        return false
      } else if (!this.selection.length) {
        this.$Message.warning('请选择锚点')
        return false
      } else this.$emit('on-select', this.selection)
    },
    handleSearch() {
      this.show = null
      this.pageIndex = 1
      this.getData()
    }
  },
  data() {
    return {
      show: null, // 请求状态
      total: 0, // 分页信息
      pageIndex: 1,
      pageSize: 10,
      search: '',
      type: '',
      dataList: [],
      selection: [], // 已选
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          key: 'anchor_id',
          title: '锚点ID',
          width: 210
        },
        {
          key: 'anchor_name',
          title: '锚点名称',
          width: 230
        },
        {
          key: 'anchor_type',
          title: '类型',
          width: 120,
          render: (h, params) => {
            let typeWord = ''
            switch (params.row.anchor_type) {
              case 'APP_GAME':
                typeWord = '游戏'
                break
              case 'APP_INTERNET_SERVICE':
                typeWord = '网服'
                break
              case 'APP_SHOP':
                typeWord = '电商'
                break
              case 'ONLINE_SUBSCRIB':
                typeWord = '高级在线预约'
                break
              default:
                break
            }
            return h('p', typeWord)
          }
        },
        {
          key: 'status',
          title: '状态',
          width: 120,
          render: (h, params) => {
            let statusWord = ''
            switch (params.row.status) {
              case 'CREATE':
                statusWord = '锚点新建'
                break
              case 'AUDIT_SUCCESS':
                statusWord = '审核通过'
                break
              case 'AUDIT_FAILD':
                statusWord = '审核不通过'
                break
              default:
                break
            }
            return h('p', statusWord)
          }
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.data-table {
  // width: 75%;
  display: inline-block;
  overflow: hidden;

  ::v-deep .ivu-table {
    width: 100%;
  }
  .filter {
    display: flex;
  }

  .input {
    width: 280px;
    margin-bottom: 8px;
  }
}

.page-index {
  margin-top: 12px;
  text-align: right;
}
</style>
